<template>
  <v-stepper
    v-if="state === 'InElaborazione' || state === 'Spedito' || state === 'Completato'"
    :value="currentStep"
    alt-labels
    flat
    class="mb-4 elevation-0"
  >
    <v-stepper-header>
      <v-stepper-step
        :complete="currentStep > 1"
        step="1"
        :color="currentStep > 1 ? 'green' : 'primary'"
      >
        {{ $t('dealer.orderDetail.stepper.inElaborazione') }}
      </v-stepper-step>
      <v-divider />
      <v-stepper-step
        :complete="currentStep > 2"
        step="2"
        :color="currentStep > 2 ? 'green' : 'primary'"
      >
        {{ $t('dealer.orderDetail.stepper.spedito') }}
      </v-stepper-step>
      <v-divider />
      <v-stepper-step
        :complete="currentStep >= 3"
        step="3"
        :color="currentStep >= 3 ? 'green' : 'primary'"
      >
        {{ $t('dealer.orderDetail.stepper.completato') }}
      </v-stepper-step>
    </v-stepper-header>
  </v-stepper>
</template>

<script>
export default {
  name: 'DealerOrderStepper',

  props: {
    state: {
      type: String,
      required: true,
    },
  },

  computed: {
    currentStep() {
      const map = {
        InElaborazione: 1,
        Spedito: 2,
        Completato: 3,
      };
      return map[this.state] || 1;
    },
  },
};
</script>
